<script lang="ts" setup>
type Props = {
  isFiltersActivated: boolean
  isFiltersDialogOpen: boolean
}

defineProps<Props>()

const emit = defineEmits(['update:model-value'])

const setFiltersDialogState = (value: boolean) => {
  emit('update:model-value', value)
}
</script>

<template>
  <the-dialog
    :model-value="isFiltersDialogOpen"
    @update:model-value="setFiltersDialogState"
  >
    <h3>Фильтры</h3>

    <div class="dialog">
      <div class="dialog__filters">
        <slot />
      </div>

      <the-button block @click="setFiltersDialogState(false)">
        Применить
      </the-button>
    </div>
  </the-dialog>
</template>

<style scoped lang="scss">
.dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-top: 10px;
}
</style>
